// extracted by css-extract-rspack-plugin
export default {"toolTip":"toolTip-VI61dg","top":"top-Ik0Rh6","right":"right-dI5yOp","bottom":"bottom-_3Oe9_","left":"left-Rt1LYX"};